export default "__VITE_ASSET__Betg8K8___"